import { z } from 'zod';

/**
 * Build the LLM-facing input schema for {@link DescribeViewsTool}.
 *
 * The `views` field is a dynamic enum derived from the available
 * {@link DataModelView} externalIds at factory time — this constrains the LLM
 * to only request schemas for views that are actually mounted, and surfaces
 * the full catalog directly in the JSON Schema so the LLM can pick by name.
 *
 * Zod's `z.enum` requires a non-empty tuple, so callers must gate on
 * `viewIds.length > 0` before constructing the schema.
 */
export function buildDescribeViewsInputSchema(viewIds: readonly [string, ...string[]]) {
  return z.object({
    views: z
      .array(z.enum(viewIds))
      .min(1)
      .describe('View externalIds to describe. Must be drawn from the available views enum.'),
  });
}

/** @public */
export type DescribeViewsInput = { views: string[] };

/** @public */
export type DescribeViewsOutput = {
  success: true;
  message: string;
};
